import React from "react";

function OralCancer() {
  return <div>OralCancer</div>;
}

export default OralCancer;
